package com.clany.backoffice.model

import kotlinx.serialization.Serializable

@Serializable
data class InvitationResponse(
    val id: String,
    val accountId: String,
    val invitedEmail: String?,
    val inviterUserId: String,
    val token: String?,
    val inviteeUserId: String?,
    val status: String,
    val createdAt: String
)
